var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8324 8.99995L13.5004 5.66795V8.16795H6.83239V9.83195H13.5004V12.3319L16.8324 8.99995ZM15.1684 13.9999C14.1185 15.3995 12.655 16.4333 10.9849 16.9549C9.31493 17.4764 7.52314 17.4593 5.86339 16.906C4.20471 16.3522 2.76222 15.2907 1.74009 13.8719C0.717958 12.453 0.167969 10.7486 0.167969 8.99995C0.167969 7.25127 0.717958 5.54688 1.74009 4.12802C2.76222 2.70917 4.20471 1.64773 5.86339 1.09395C7.52314 0.540589 9.31493 0.523474 10.9849 1.04503C12.655 1.56658 14.1185 2.60037 15.1684 3.99995H12.8914C11.6019 2.86153 9.92209 2.26605 8.20351 2.33818C6.48494 2.41032 4.8609 3.14447 3.67139 4.38695C2.47982 5.62706 1.81435 7.28015 1.81435 8.99995C1.81435 10.7197 2.47982 12.3728 3.67139 13.6129C4.8609 14.8554 6.48494 15.5896 8.20351 15.6617C9.92209 15.7339 11.6019 15.1384 12.8914 13.9999H15.1684Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOut);
export default __webpack_public_path__ + "static/media/check-out.1fe8811b34de39c3e4662ad643b2780d.svg";
export { ForwardRef as ReactComponent };